<template>
  <div class="my-header" :style="navStyle" v-resize="handleResize">
    <nav class="navbar navbar-default">
      <div class="container-fluid">
        <!-- Brand and toggle get grouped for better mobile display -->
        <div class="navbar-header">
          <button
            type="button"
            class="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
            aria-expanded="false"
          >
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <div class="navbar-brand">
            {{ getConfig("customerTitle") }}
            <span style="font-size: 12px">
              {{ readState("userProfile.customerInfo.name") }}
            </span>
          </div>
        </div>

        <!-- Collect the nav links, forms, and other content for toggling -->
        <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
          <ul class="nav navbar-nav">
            <template v-for="(item, index) in menus">
              <template v-if="item.children && item.children.length > 0">
                <li class="dropdown">
                  <a
                    href="#"
                    class="dropdown-toggle"
                    data-toggle="dropdown"
                    role="button"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i
                      v-if="item.icon"
                      :class="item.icon"
                      style="margin-right: 5px"
                    ></i>
                    {{ item.label }} <span class="caret"></span>
                  </a>
                  <ul class="dropdown-menu">
                    <template v-for="(children, cIndex) in item.children">
                      <li @click="handleMenuClick(children)">
                        <a>
                          <i
                            v-if="children.icon"
                            :class="children.icon"
                            style="margin-right: 5px"
                          ></i>
                          <span>{{ children.label }}</span>
                        </a>
                      </li>
                    </template>
                  </ul>
                </li>
              </template>
              <template v-else>
                <li @click="handleMenuClick(item)">
                  <a href="#">
                    <i
                      v-if="item.icon"
                      :class="item.icon"
                      style="margin-right: 5px"
                    ></i>
                    {{ item.label }}
                  </a>
                </li>
              </template>
            </template>
          </ul>
          <ul class="nav navbar-nav navbar-right">
            <li class="dropdown">
              <a
                role="button"
                class="dropdown-toggle"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                {{ readState("userProfile.nickname") }}
                <span class="caret"></span>
              </a>
              <ul class="dropdown-menu">
                <li @click="openRoutePage('/account/profile')">
                  <a>个人资料</a>
                </li>
                <li role="separator" class="divider"></li>
                <li @click="openRoutePage('/login')">
                  <a>退出登录</a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <!-- /.navbar-collapse -->
      </div>
      <!-- /.container-fluid -->
    </nav>
  </div>
</template>

<style lang="less" scoped>
.my-header {
  .navbar {
    border-radius: 0px;
    margin-bottom: 0px;
  }
  .dropdown-menu > li > a {
    padding: 10px 20px;
    cursor: pointer;
  }

  .navbar-default {
    background-color: var(--navbar-background-color);
    border-color: var(--navbar-border-color);
  }

  .navbar-default .navbar-nav > li > a {
    color: var(--navbar-text-color); /* 链接文字颜色 */
  }

  .navbar-default .navbar-nav > li > a:hover,
  .navbar-default .navbar-nav > li > a:focus {
    color: var(--navbar-text-hover-color);
    background-color: var(--navbar-background-hover-color);
  }

  .navbar-default .navbar-nav > .open > a,
  .navbar-default .navbar-nav > .open > a:hover,
  .navbar-default .navbar-nav > .open > a:focus {
    color: var(--navbar-text-hover-color);
    background-color: var(--navbar-background-hover-color);
  }

  .navbar-default .navbar-brand {
    color: var(--navbar-brand-color);
  }

  .navbar-default .navbar-brand:hover {
    color: var(--navbar-brand-hover-color);
  }

  .navbar-default .navbar-toggle:hover,
  .navbar-default .navbar-toggle:focus {
    background-color: var(--navbar-background-hover-color);
  }

  .navbar-default .navbar-toggle .icon-bar {
    background-color: var(--navbar-brand-color);
  }

  @media (max-width: 767px) {
    .navbar-default .navbar-nav .open .dropdown-menu > li > a {
      color: #ffffff;
    }
  }
}
</style>

<script>
export default {
  data() {
    return {
      userLoading: false,
      userErrorMsg: null,
    }
  },
  props: {
    menus: {
      type: Array
    },
    showCollapseBtn: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    adminNickname() {
      return this.readState("userProfile.nickname");
    },
    navStyle() {
      let textColor = this.readState('userProfile.customerInfo.themeTextColor') || '#FFFFFF'
      let bgColor = this.readState('userProfile.customerInfo.themeColor') || '#47778f'
      return {
        '--navbar-brand-hover-color': this.getDarkColor(textColor, 0.2),
        '--navbar-brand-color': textColor,
        '--navbar-background-hover-color': this.getDarkColor(bgColor, 0.2),
        '--navbar-background-color': bgColor,
        '--navbar-border-color': this.getDarkColor(bgColor, 0.2),
        '--navbar-text-hover-color': this.getDarkColor(textColor, 0.2),
        '--navbar-text-color': textColor
      }
    },
    adminMenus() {
      return {
        label: this.adminNickname || "更多",
        menus: [
          {
            path: "/system/profile",
            label: "个人资料",
            type: "drawer",
          },
          {
            path: "/login",
            label: "退出登录",
          },
        ],
      }
    }
  },
  methods: {
    handleMenuClick(menu) {
      if (!menu.path) {
        return;
      }
      if (menu.type == "drawer") {
        this.openRouteDrawer(menu.path);
      } else {
        this.openRoutePage(menu.path);
        return true;
      }
    },
    handleResize() {
      if (!this.inPc()) {
        return;
      }
      this.bridgeCall("isFullScreen").then((fullScreen) => {
        this.commitState({ clientFullScreen: fullScreen });
      })
    },
    fullScreenClick() {
      if (!this.inPc()) {
        return;
      }
      let fullScreenFlag = this.readState("clientFullScreen");
      this.commitState({ clientFullScreen: !fullScreenFlag });
      this.autoFullScreen();
    },
    autoFullScreen() {
      if (!this.inPc()) {
        return;
      }
      let fullScreenFlag = this.readState("clientFullScreen");
      this.bridgeCall("setFullScreen", { fullscreen: fullScreenFlag })
    },
    handleMenuEvent(event) {
      if (event.type == "drawer") {
        this.openRouteDrawer(event.redirect || event.path);
      } else {
        this.openRoutePage(event.redirect || event.path);
      }
    },
    fetchProfileInfo() {
      if (this.userLoading) {
        return;
      }
      this.userLoading = true;
      this.userErrorMsg = null;
      return this.requestApi("biz.customer.account.auth.profile").then((resp) => {
        this.commitState({ userProfile: resp.data });
      }).catch((err) => {
        this.userErrorMsg =
          (err && (err.msg || err.message)) || "连接服务器失败，请检查网络";
      }).finally(() => {
        this.userLoading = false;
      });
    },
  },
  mounted() {
    this.fetchProfileInfo();
    this.autoFullScreen();
  }
}
</script>

<style>
</style>